import { Link } from "react-router-dom";
import { Sparkles, Heart, ShieldCheck, Home, ArrowRight } from "lucide-react";

const BG = "https://static.prod-images.emergentagent.com/jobs/c36a8fad-3db1-43ac-a499-952035e476fa/images/6caba51d7492872234ec31fd4c9f631cf293d605214010474c72dd10123ee18e.png";

export default function Landing() {
  return (
    <div className="min-h-screen bg-cream relative" data-testid="landing-page">
      {/* Header */}
      <header className="px-6 md:px-12 py-6 flex items-center justify-between border-b border-warm">
        <div className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-md bg-terracotta flex items-center justify-center text-white">
            <Sparkles className="h-4 w-4" />
          </div>
          <div className="font-heading text-2xl text-deep tracking-tight">Cozy Heaven</div>
        </div>
        <div className="flex items-center gap-3">
          <a
            href="https://www.thecozyheaven.com/"
            target="_blank" rel="noreferrer"
            className="hidden sm:inline-block text-sm text-warm hover:text-deep"
          >
            Visit main site
          </a>
          <Link
            to="/login"
            data-testid="header-login-btn"
            className="bg-terracotta text-white px-5 py-2 rounded-md text-sm hover:scale-[1.02] active:scale-[0.98] transition-transform"
          >
            Sign in
          </Link>
        </div>
      </header>

      {/* Hero */}
      <section className="px-6 md:px-12 lg:px-20 py-14 md:py-20 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7 animate-fade-up">
          <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-[#A67B5B] mb-6">
            <span className="h-px w-8 bg-[#A67B5B]" /> Resident & Admin Portal
          </div>
          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl text-deep leading-[1.02] tracking-tight">
            A warm little<br/>
            <span className="italic text-[#C86F58]">home away from home</span>,<br/>
            beautifully organised.
          </h1>
          <p className="mt-6 text-warm text-lg max-w-xl leading-relaxed">
            The official Cozy Heaven portal for our residents and warden team — fees,
            notices, maintenance tickets, leave requests and visitor logs, all in one
            quiet, well-lit place.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/login"
              data-testid="hero-login-btn"
              className="bg-terracotta text-white px-6 py-3 rounded-md text-sm font-medium hover:scale-[1.02] active:scale-[0.98] transition-transform inline-flex items-center gap-2"
            >
              Sign in to portal <ArrowRight className="h-4 w-4" />
            </Link>
            <a
              href="https://www.thecozyheaven.com/"
              target="_blank" rel="noreferrer"
              className="px-6 py-3 rounded-md text-sm border border-warm text-deep hover:bg-[#F4F1EA] inline-flex items-center gap-2"
            >
              Learn about Cozy Heaven
            </a>
          </div>

          <div className="mt-12 grid sm:grid-cols-3 gap-4">
            <Feature icon={Heart} title="For residents" body="Pay info, raise tickets, request leave, read notices." />
            <Feature icon={ShieldCheck} title="For wardens" body="Track fees, approve leave, monitor visitors." />
            <Feature icon={Home} title="One quiet place" body="No spreadsheets, no chasing, just clarity." />
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="aspect-[4/5] rounded-lg overflow-hidden border border-warm shadow-[0_24px_60px_-30px_rgba(168,105,80,0.35)]">
            <img src={BG} alt="Cozy interior" className="h-full w-full object-cover" />
          </div>
          <div className="absolute -bottom-4 -left-4 bg-white border border-warm rounded-md px-4 py-3 hidden md:block">
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#A67B5B]">since 2024</div>
            <div className="font-heading text-xl text-deep">thecozyheaven.com</div>
          </div>
        </div>
      </section>

      <footer className="px-6 md:px-12 py-6 border-t border-warm text-sm text-warm flex flex-col sm:flex-row justify-between gap-2">
        <div>© {new Date().getFullYear()} Cozy Heaven — Girls PG</div>
        <div>Built with care for our residents.</div>
      </footer>
    </div>
  );
}

function Feature({ icon: Icon, title, body }) {
  return (
    <div className="border border-warm rounded-md p-4 bg-white card-lift">
      <Icon className="h-5 w-5 text-[#C86F58] mb-3" />
      <div className="font-medium text-deep">{title}</div>
      <div className="text-xs text-warm mt-1 leading-relaxed">{body}</div>
    </div>
  );
}
